<template>
  <!--Landing>
    这是霍尼韦尔的定制登录界面
    <Login @ready-for-login="sendLoginRequest" @ready-to-get-code="getAuthCode" :user="user"></Login>
  </Landing-->
  <div class="xo-fullpage-wrapper">
    <div class="xo-header">
      <div class="xo-header-brand xo-pointer">
        <img src="./img/logo.png"  />
      </div>
      <!--<div class="xo-header-actions">-->
        <!--<span class="xo-pointer">注册</span>-->
      <!--</div>-->
    </div>
    <div class="xo-login-container">
      <div class="xo-row-gap">
        <img src="./img/logo-lg.png" alt="honeywell" width="200">
      </div>
      <div class="xo-login-box">
        <div class="xo-inline-block xo-login-box-banner"><img src="./img/sliders/1.jpg" alt="" />
        </div><!-- 消除div之间的Gap
            --><div class="xo-inline-block xo-login-box-form">
        <div class="xo-login-box-form-inner">
          <div class="xo-login-box-form-padding">
            <h2 class="title-highlight">用户登录</h2>
          </div>
          <LoginForm @ready-for-login="sendLoginRequest" @ready-to-get-code="getAuthCode" :user="user"></LoginForm>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Landing from '@/page/byl/landing.vue'
  import Login from '@/components/common/login/login.vue'
  import LoginForm from '@/page/hsm/loginForm'
  import { saveCookie, getCookie, removeCookie } from '@/store/cookies.js'
  import { mapState, mapActions } from 'vuex'
  export default {
    components: { Landing, Login, LoginForm },
    mounted () {
    },
    data () {
      return {
        user: null
      }
    },
    computed: {
      ...mapState('auth', ['isLogined'])
    },
    methods: {
      ...mapActions('auth', {
        localLogin: 'localLogin',
        codeLogin: 'codeLogin',
        getCode: 'getCode'
      }),
      sendLoginRequest (data) {
        var user = data
        if (user.checked === true) { // 判断复选框是否被勾选 勾选则调用配置cookie方法
          var p = {
            phone: user.accountName,
            password: user.password
          }
          saveCookie('rme_fresh', p) // 保存记住我状态
        } else {
          removeCookie('rme_fresh')
        }
        this.localLogin(user)
      },
      getAuthCode (phone) {
        if (phone && phone !== (null || undefined || '')) {
          this.getCode(phone)
        }
      }
    }
  }
</script>
<style scoped>
  @import './hsm.css';
</style>



// WEBPACK FOOTER //
// src/page/hsm/login.vue